import Scene from "./Scene";
import common from "../common";
import {translate} from "../utils";
import Drawing from "../drawing/Drawing";
import World from "../game/World";
import TutorialFinger from "../ui/TutorialFinger";

export default class GameScene extends Scene {

    constructor() {
        super();

        //this._paths = [];

    }

    init() {
        super.init();

        // this sets paperjs up
        this._drawing = new Drawing();
        this._drawing.init();

        this._world = new World();
        this._world.position.set(0, common.STAGE_HEIGHT - 80); // make world origin so 0,0 is bottom left corner
        this._world.signals.began.once(this._onBegin, this);
        this._world.signals.completed.once(this._onComplete, this);
        this.addChild(this._world);

        // we only needed the drawing for the paperjs canvas, so we can destroy after creating world
        this._drawing.destroy();

        this._interactionLayer = new PIXI.Container();
        this._interactionLayer.hitArea = new PIXI.Rectangle(0, 0, common.STAGE_WIDTH, common.STAGE_HEIGHT);
        this._interactionLayer.mousedown = this._interactionLayer.touchstart = this._onDown.bind(this);
        this._interactionLayer.mouseup = this._interactionLayer.mouseupoutside = this._interactionLayer.touchend = this._onUp.bind(this);
        this._interactionLayer.mousemove = this._interactionLayer.touchmove = this._onMove.bind(this);
        this._interactionLayer.interactive = true;
        this.addChild(this._interactionLayer);

        this._down = false;

        this._tutorialFinger = new TutorialFinger();
        this._tutorialFinger.visible = false;
        this.addChild(this._tutorialFinger);

        this._running = false;
    }

    destroy() {
        super.destroy();
    }

    resize() {
        super.resize();
        this._tutorialFinger.position.set((common.STAGE_WIDTH + P3.View.width) * 0.5 - 140, common.STAGE_HEIGHT - 220);
    }

    animateIn() {
        this._world.begin();
    }

    update(dt = window.deltaTime) {
        super.update();

        this._world.update(dt);
        this._tutorialFinger.update();

        if (P3.input.isKeyDown(P3.keys.UP)) {
            this._tutorialFinger.visible = false;
            this._world.moveTarget.y -= dt * 900;
        }
        if (P3.input.isKeyDown(P3.keys.DOWN)) {
            this._tutorialFinger.visible = false;
            this._world.moveTarget.y += dt * 900;
        }
    }

    end() {
        this.signals.next.dispatch();
    }

    _onDown() {
        if (this._running) {
            this._down = true;
            this._tutorialFinger.visible = false;
        }
    }

    _onUp() {
        if (this._running)
            this._down = false;
    }

    _onMove(event) {
        if (this._running && this._down) {
            this._world.moveTarget = event.data.getLocalPosition(this._world);
        }
    }

    _onBegin() {
        this._running = true;

        this._tutorialFinger.alpha = 0;
        this._tutorialFinger.visible = true;

        new P3.utils.TWEEN.Tween(this._tutorialFinger, this._tweens)
            .to({alpha: 1}, 820)
            .easing(P3.utils.TWEEN.Easing.Quadratic.In)
            .onComplete(() => this._tutorialFinger.animate())
            .start();
    }

    _onComplete() {
        this.end();
    }
}

